"use client";

import Link from "next/link";
import { useEffect, useState } from "react";

/**
 * Small announcement toast linking to /board.
 */
export function BoardToast() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setVisible(true), 600);
    return () => clearTimeout(timeout);
  }, []);

  if (!visible) return null;

  return (
    <Link
      href="/board"
      className="board-toast-shine z-50 flex flex-col rounded-2xl px-4 py-2.5 text-[13px] leading-[1.4] text-foreground"
    >
      <span className="font-medium">See this site as a board</span>
      <span className="opacity-60">Pan around cases, photos and experiments</span>
    </Link>
  );
}
